module.exports = "../images/fishing-lodge-08.jpg?v=a00a29e";